<div class="toolbar">
  <div>
    <div class="btnArrow navToggleBtn">
      <div
        [ngClass]="!sideNavStatus ? 'rotateLeft' : 'rotateRight'"
        class="hide-menu"
        (click)="onToggleSideNav()"
      >
        <mat-icon style="width: 30px; color:black;" class="pointer unselectable"
          >menu_open</mat-icon
        >
      </div>
    </div>
  </div>
  <div class="col-md-7">
    <app-section-title title="{{ titleSection }}"></app-section-title>
  </div>
  <div class="col-md-4">
    <div class="langUser float-right">
      <ul class="list-inline">
        <li class="list-inline-item">
          <div class="usuario">
            <app-timezone></app-timezone>
          </div>
        </li>
        <li class="list-inline-item">
          <!-- *ngIf="titleSection === 'TITLES.DEVICES' "-->
          <button
            mat-button
            class="factoryOption"
            [matBadge]="numberOfFactorySelected"
            matBadgeOverlap="true"
            [matMenuTriggerFor]="menu"
          >
            <!-- <app-svg name="factory" class="factorySelection"></app-svg> -->
            <span class="material-icons" style="color: black"> business </span>
          </button>

          <mat-menu #menu class="factorySelectionMenu userMenu">
            <div *ngFor="let factory of factoryCollection?.collection">
              <mat-checkbox
                [checked]="isOnlyOneFactory"
                class="mat-menu-item factoryMenu"
                (click)="onSelectFactory(factory)"
                >{{ factory.name }}</mat-checkbox
              >
            </div>
          </mat-menu>
        </li>
        <li class="list-inline-item">
          <app-alarma-badge></app-alarma-badge>
        </li>
        <li class="list-inline-item">
          <div class="usuario">
            <app-user-account></app-user-account>
          </div>
        </li>
      </ul>
    </div>
  </div>
  <div class="col-md-1">
    <div class="idioma">
      <app-idioma></app-idioma>
    </div>
  </div>
</div>
